import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  brandingApi,
  resolveLogoSrc,
  resolveUserOrganisationBrandingId,
} from '../lib/branding';
import { organisationsApi } from '../lib/organisations';
import { useAuth } from './useAuth';

/** Logged-in user's organisation branding for dashboard header. */
export function useHeaderBranding() {
  const { user } = useAuth();
  const organisationId = user?.organisationId ?? null;

  const { data: organisation } = useQuery({
    queryKey: ['organisation', organisationId],
    queryFn: () => organisationsApi.getById(organisationId!),
    enabled: !!organisationId,
  });

  const brandingId = useMemo(
    () => resolveUserOrganisationBrandingId(organisationId, organisation),
    [organisationId, organisation],
  );

  const { data: branding } = useQuery({
    queryKey: ['branding', brandingId],
    queryFn: () => brandingApi.getById(brandingId!),
    enabled: !!brandingId,
  });

  const logoSrc = branding ? resolveLogoSrc(branding.publicLogoPath) : null;

  return {
    logoSrc,
    name: branding?.name ?? null,
  };
}
